import React, { useEffect, useCallback, useState} from 'react';
import {setModuleCollapsed} from 'actions/index.js';
import {connect} from 'react-redux';
import '../../Modules.scss';

const GridTab = ({subSequence, collapsed, isCurrent, setCollapsed}) => { 
    let className="module-tab grids-name";
    if (isCurrent) {
        className += " selected";
    }
    return (
        <div className={className}>
          {subSequence.name}
          <div onClick={() => setCollapsed(!collapsed)} className="collapse-button">
            <div className={collapsed ? "arrow-left" : "arrow-down"}/>
          </div>
        </div>);
      
};

const mapStateToProps = (state, props) => {
  return {
      collapsed: state.pads.modulesCollapsed[props.subSequence.id],
      isCurrent: props.subSequence === props.subSequence.sequencerEngine.currentSubSequence
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setCollapsed: (x) => dispatch(setModuleCollapsed(props.subSequence.id, x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GridTab);
